module.exports = {"130530100":"新河镇","130530101":"寻寨镇","130530200":"白神首乡","130530201":"荆家庄乡","130530202":"西流乡","130530203":"仁让里乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130530.json
// module id = 143
// module chunks = 0